import { Component, Mixins, Prop } from 'vue-property-decorator';
import addPopularSuggestionMutation from '../../mutations/addPopularSuggestion';
import popularSuggestionQuery from '../../queries/popularSuggestions';
import { UtilMixin } from '../../UtilMixin';
import SingleMainContainer from '../shared/singleMainContainer.vue';
import BooksCarousel from './booksCarousel.vue';

@Component({ components: { BooksCarousel, SingleMainContainer } })
export default class SuggestionsListPopularAdder extends Mixins(UtilMixin) {
  @Prop() public suggestionsList!: any;

  public readonly query = popularSuggestionQuery;
  public readonly mutation = addPopularSuggestionMutation;

  public mutationVariables(suggestionCandidate: any) {
    return {
      suggestionsListId: this.suggestionsList.id,
      publicationUrl: this.findSelfUrl(suggestionCandidate.publication),
      loans: suggestionCandidate.source.loans,
      libraries: suggestionCandidate.source.libraries,
    };
  }
}
